// extracted by mini-css-extract-plugin
module.exports = {"Page":"ManagerMarket_Page__2lfSZ","NameGroup":"ManagerMarket_NameGroup__2dU6q","CategoryList":"ManagerMarket_CategoryList__1PhM8"};